
import Vue from 'vue'
import { Step } from '../store'
import { StandardButton } from '@/components/buttons'
import ErrorMessages from './ErrorMessages.vue'
import CheckboxRecaptcha from './CheckboxRecaptcha.vue'

interface StepAction {
   nextStepLabel: string
   canMoveNext: boolean
   nextStepAction: () => void
   previousStepLabel: string
   previousStepAction: () => void
}

export default Vue.extend({
   name: 'ActionButtons',
   computed: {
      step(): Step {
         return this.$store.state.step
      },
      processingCheckout(): boolean {
         return this.$store.state.processingCheckout
      },
      canStartCheckout(): boolean {
         return this.$store.state.accountType !== 'unknown'
      },
      requiresRecaptcha(): boolean {
         return this.step === 'payment'
      },
      requiresDelivery(): boolean {
         return this.$store.getters.requiresDelivery
      },
      stepAction(): StepAction | null {
         switch (this.step) {
            case 'information':
               return {
                  canMoveNext: this.$store.getters.canCompleteInformationStep,
                  nextStepLabel: 'Continue to Order Type',
                  nextStepAction: () => this.$store.commit('setStep', 'order_type'),
                  previousStepLabel: 'Return to Cart',
                  previousStepAction: () => (window.location.href = '/Store/Cart'),
               }
               break
            case 'order_type':
               return {
                  canMoveNext: this.$store.getters.canCompleteOrderTypeStep,
                  nextStepLabel: this.requiresDelivery
                     ? 'Continue to Shipping'
                     : 'Continue to Payment',
                  nextStepAction: () =>
                     this.$store.commit('setStep', this.requiresDelivery ? 'shipping' : 'payment'),
                  previousStepLabel: 'Return to Information',
                  previousStepAction: () => this.$store.commit('setStep', 'information'),
               }
               break
            case 'shipping':
               return {
                  canMoveNext: this.$store.getters.canCompleteShippingStep,
                  nextStepLabel: 'Continue to Payment',
                  nextStepAction: () => this.$store.commit('setStep', 'payment'),
                  previousStepLabel: 'Return to Order Type',
                  previousStepAction: () => this.$store.commit('setStep', 'order_type'),
               }
               break
            case 'payment':
               return {
                  canMoveNext: this.$store.getters.canCompletePaymentStep,
                  nextStepLabel: 'Pay Now',
                  nextStepAction: () => this.$store.dispatch('completeCheckout'),
                  previousStepLabel: this.requiresDelivery
                     ? 'Return to Shipping'
                     : 'Return to Order Type',
                  previousStepAction: () =>
                     this.$store.commit(
                        'setStep',
                        this.requiresDelivery ? 'shipping' : 'order_type'
                     ),
               }
               break
            default:
               return null
         }
      },
      nextStepLabel(): string {
         const action = this.stepAction
         return action ? action.nextStepLabel : ''
      },
      previousStepLabel(): string {
         const action = this.stepAction
         return action ? action.previousStepLabel : ''
      },
   },
   methods: {
      doNextStep() {
         const action = this.stepAction
         if (action === null) {
            return
         }
         if (action.canMoveNext) {
            this.$store.commit('setShowErrors', false)
            action.nextStepAction()
            this.scrollToTop()
         } else {
            this.$store.commit('setShowErrors', true)
         }
      },
      doPreviousStep() {
         const action = this.stepAction
         if (action === null) {
            return
         }
         action.previousStepAction()
         this.scrollToTop()
      },
      scrollToTop() {
         window.scrollTo({
            top: 100,
            left: 0,
            behavior: 'smooth',
         })
      },
   },
   components: {
      StandardButton,
      ErrorMessages,
      CheckboxRecaptcha,
   },
})
